export class TransportSectionFieldAliases {
  static TYPE_INPUT = 'type'
  static TYPE_FROM_STS_INPUT = 'type_from_sts'
  static NUMBER_PLATE = 'number'
  static NUMBER_PLATE_TRAILER = 'trailer'
  static MARK = 'mark'
  static MODEL = 'model'
  static COLOR = 'color'
  static OWNER = 'owner'
  static USER_POSITION = 'user_position'
}
